import { Switch } from "@headlessui/react";

export default function Toggle({
  value,
  onChange,
  label,
  labelPosition = "left",
  size = "default",
  layout = "horizontal",
  labelClassName = "",
  className = "",
}: {
  value: boolean;
  onChange: (value: boolean) => void;
  label: string;
  labelPosition?: string;
  size?: "small" | "default";
  layout?: string;
  labelClassName?: string;
  className?: string;
}) {
  const sizeClasses = {
    small: "h-[22px] w-[42px]",
    default: "h-[38px] w-[74px]",
  };

  const thumbSizeClasses = {
    small: "h-[18px] w-[18px]",
    default: "h-[34px] w-[34px]",
  };

  const translateClasses = {
    small: "translate-x-5",
    default: "translate-x-9",
  };

  const renderToggle = () => (
    <Switch
      checked={value}
      onChange={onChange}
      className={`${value ? "bg-blue-100" : "bg-zinc-200"}
              relative inline-flex shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75
              ${sizeClasses[size]}`}
    >
      <span
        aria-hidden="true"
        className={`${value ? translateClasses[size] : "translate-x-0"}
                pointer-events-none inline-block transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out
                ${thumbSizeClasses[size]}`}
      />
    </Switch>
  );

  const renderLabel = () => (
    <Switch.Label
      className={`flex-shrink-0 cursor-pointer whitespace-nowrap hover:underline ${
        size === "small" ? "text-sm" : ""
      } ${labelClassName}`}
    >
      {label}
    </Switch.Label>
  );

  return (
    <Switch.Group>
      <div
        className={`flex items-center ${
          layout === "vertical" ? "flex-col" : "flex-row justify-between"
        } ${layout === "vertical" ? "gap-2" : "gap-2"} ${className}`}
      >
        {labelPosition === "left" ? (
          <>
            {renderLabel()}
            {renderToggle()}
          </>
        ) : (
          <>
            {renderToggle()}
            {renderLabel()}
          </>
        )}
      </div>
    </Switch.Group>
  );
}
